module.exports = __webpack_public_path__ + "static/img/modern.114cbc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/modern.jpg
// module id = uLwN
// module chunks = 0